import { useQuery } from '@tanstack/react-query';

import { DefaultResponse } from 'src/api/api.types';
import { TenantType } from 'src/types';
import { QueryOptions } from 'src/utils/libs/reactQuery';
import { tenantService } from '../tenant.service';

const useTenants = (params?: any, options?: QueryOptions<DefaultResponse<TenantType[]>>) => {
  const { data: tenantsData = { payload: [], status: false }, ...rest } = useQuery({
    queryKey: ['tenants', params],
    queryFn: () => tenantService.getMany(params),
    ...options,
  });

  const tenants = tenantsData.payload;

  return { tenants, tenantsData, ...rest };
};

export default useTenants;
